"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.filter");

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _themeSections = require("@shopify/theme-sections");

require("../sections/redirect-modal");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Helper: Redirects
 * ------------------------------------------------------------------------------
 * An event based redirect module listening for language/location event changes.
 *
 * @namespace redirects
 */

/**
 * Export new redirect helper function.
 */


var _default = function _default() {
  /**
   * Initialise component.
   */
  function init() {
    setListeners();
    handleRedirectWarning();
  }
  /**
   * Set component listeners.
   */


  function setListeners() {
    Frame.EventBus.listen('LanguageSelector:change', function (response) {
      return onLanguageChange(response);
    });
  }
  /**
   * Handle GeoIP country code and store country code matching.
   * @param {object} response - ipstack success response.
   */


  function onLanguageChange(response) {
    handleRedirects(response);
  }
  /**
   * Handle url redirect locations.
   * @param {object} response - ipstack success response.
   */


  function handleRedirects(response) {
    window.setTimeout(function () {
      window.location = getRedirectURL(response.selected);
    }, 1500);
  }
  /**
   * Get redirect URL defined in redirect modal section.
   * @param {String} location - Location country/continent code.
   */


  function getRedirectURL(location) {
    return Frame.Redirects.filter(function (element) {
      return element.country_code === location || element.continent_code === location;
    })[0].store_url;
  }
  /**
   * Check if user is coming from a location that doesn't match the store.
   */


  function handleRedirectWarning() {
    if (isCookieSet() && _jsCookie["default"].get('default_language') !== theme.store.countryCode) {
      (0, _themeSections.load)('*');
    }
  }
  /**
   * Check if cookies have been set.
   */


  function isCookieSet() {
    return typeof _jsCookie["default"].get('default_language') !== 'undefined';
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init: init
  });
};

exports["default"] = _default;